const isAlphaNumeric = (testString: string) => {
    let code, i, len;

    let numberExists = false
    let alphabetExists = false

    for (i = 0, len = testString.length; i < len; i++) {

        if (numberExists && alphabetExists) break
        
        code = testString.charCodeAt(i);
        
        if (code > 47 && code < 58) {
            numberExists = true
        }

        if ((code > 64 && code < 91) || (code > 96 && code < 123)) {
            alphabetExists = true
        }

    }
    
    return numberExists && alphabetExists ? true : false
}

const isNumeric = (value: string | number) => !isNaN(Number(value))


export { isAlphaNumeric, isNumeric }